/**
 * MIME type of the Blob output.
 *
 * @type {string}
 */
export const MIME_TYPE = 'text/calendar'



// WEBPACK FOOTER //
// ./src/constants.js